module.exports = __webpack_public_path__ + "static/img/img8.8bd7a5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/img8.png
// module id = DrNa
// module chunks = 1